module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/mini_sans-medium-web.ttf?b39b7f290f5ebe0331af2642da31a004";